import { useFlagMe61741ViewSlackEmployeeTree } from '@generated/flags/ME-61741-view-slack-employee-tree';

export const useViewSlackEmployeeTreeFlag = (): boolean => {
  const useViewSlackEmployeeTree = useFlagMe61741ViewSlackEmployeeTree();
  return useViewSlackEmployeeTree;
};
